import { BaseFilterCellComponent } from '@progress/kendo-angular-grid';

export abstract class BaseCustomFilterComponent extends BaseFilterCellComponent {
  abstract resetDefault(): void;
}
